import { useCallback } from 'react';
import { useEventHub, CommentEventType } from '@pwc/event-hub-ui';
import { useMobile } from '@pwc/pwc-deals-web-common';
import { getFakeClientUser } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { isInlineCommentingEnabled } from 'common/helpers/featureFlags';
import { useDispatch, useSelector } from 'react-redux';
import { setCommentPanelOpened } from 'features/comments/commentsSlice';

export const useShowInlineComments = () => {
  const { eventHub } = useEventHub();
  const dispatch = useDispatch();
  const isMobile = useMobile();
  const isFakeClientUser = useSelector(getFakeClientUser);

  const showComments = useCallback(
    (showComment: boolean) => {
      const eventName = '@commenting-show-comment-threads' as CommentEventType;

      if (!isMobile) {
        eventHub?.publish(eventName, showComment);
      } else if (sessionStorage.getItem('isCommentHighlightsOn') === 'ON') {
        eventHub?.publish(eventName, true);
      } else {
        eventHub?.publish(eventName, false);
      }
    },
    [eventHub, isMobile]
  );

  const setDefaultCloseCommentPanel = useCallback(() => {
    if (isInlineCommentingEnabled && !isFakeClientUser) {
      dispatch(setCommentPanelOpened(false));
    }
  }, [dispatch, isFakeClientUser]);

  return {
    showComments,
    setDefaultCloseCommentPanel,
  };
};
